import React, { useState } from 'react'
import PageHeader from '../../../Component/BasicComponents/HeaderBreadCrumbs';
import CustomerTable from './CustomerTable'
import RouteModal from '../../../Component/BasicComponents/Modal/RouteModal';
import CustomerModal from './Modal/CustomerModal';
import AddressModal from './Modal/AddressModal';
import OrganizationCustomerRecordModal from './Modal/OrganizationCustomerRecordModal';
import BeatOutletModal from './Modal/BeatOutletModal';
import axiosInstance from '../../../Api/axiosInstance';
import { API_ENDPOINTS } from '../../../Api/apiEndPoints';
import { useExcelPolling } from '../../../hooks/useExcelPolling';
import { showToast } from '../../../utils/toastUtils';
import { COLORS } from '../../../constants/colors';

const CustomerScreen:React.FC =()=>{
   
  const [isModal,setIsModal]  = useState(false);   
    const [isEditMode, setIsEditMode] = useState(false); 
    const [customerId, setCustomerId] = useState<number | undefined>(undefined)
      const [mode, setMode] = useState<"add" | "edit">("add");
      const [newOutletOrgDataId, setNewOutletOrgDataId] = useState<number | null>(null);
      const { startPolling, stopPolling } = useExcelPolling();


    

  const [isDownloading,setIsDownloading]=useState(false)
       const [isCustomerModal, setIsCustomerModal] = useState(false);
  const [isAddressModal, setIsAddressModal] = useState(false);
  const [newCustomerId, setNewCustomerId] = useState<number | null>(null);
const [isOrganizationModal, setIsOrganizationModal] = useState(false);
const [isBeatModal, setIsBeatModal] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

const [filtersData, setFiltersData] = useState<any>({});

console.log('filter ka data',filtersData)


        const [currentStep, setCurrentStep] = useState<
    "customer" | "address" | "organization" | "beat" | null
  >(null);

    const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
    const orgUnit = filtersData?.orgUnit || "";
    const page = filtersData?.page || "";
    const limit = filtersData?.limit || "";
    const search = filtersData?.search || "";
    const territory =filtersData.territory||"";
    const outletType =filtersData.outletType||"";
    const classification=filtersData.classification||"";

    const params = new URLSearchParams();

    // Append only if the value exists
    if (orgUnit) params.append("orgUnit", orgUnit);
    if (outletType) params.append("outletType", outletType);
    if (classification) params.append("classification", classification);
    if (territory) params.append("territory", territory);
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);
    if (search) params.append("search", search);
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.Cutomer.GET_OUTLETS_LIST_EXCEL}?${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };


    
   const handleAddOutlet = () => {
    setNewCustomerId(null);
    setIsCustomerModal(true);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    setCurrentStep(null);
  };
    return (
      <div className="p-2">
        <PageHeader title='Customer'
         buttons={[
           {
             label: "+Add Outlets",
             onClick: handleAddOutlet,
             color:'#2e8dd3'
           },
           {
           label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
            onClick:downloadExcelGet,
          color: loadingExcel ? COLORS.disable : COLORS.primary,
                      disable: loadingExcel ? true : false,
           },
           {
             label: "CSV",
             onClick: () => alert("Add CSV"),
             color: "#43B9B2",
           },
         ]}
        
        />
        <CustomerTable setFiltersData={setFiltersData}/>

      <RouteModal
        size="xl"
        isOpen={isCustomerModal}
        title="Add Outlet"
        toggle={() => setIsCustomerModal(!isCustomerModal)}
        content={
          <CustomerModal
            mode="add"
            customerID={customerId}
            modalClose={() => setIsCustomerModal(false)}
            onSuccess={(outletId) => {
              setNewCustomerId(outletId);
              setIsCustomerModal(false);
              setIsAddressModal(true);
            }}
          />
        }
      />

      <RouteModal
        size="md"
        isOpen={isAddressModal}
        title="Add Address"
        toggle={() => setIsAddressModal(!isAddressModal)}
        content={
           <AddressModal
      customerId={newCustomerId!}
      modalClose={() => setIsAddressModal(false)}
      mode="add"
      OutletId={newCustomerId!}
      onSuccess={() => {
        setIsAddressModal(false);
        setIsOrganizationModal(true); // <-- Open Organization after Address
      }}
    />
        }
      />

       <RouteModal
        size="lg"
        isOpen={isOrganizationModal}
        title="Add Organization"
        toggle={() => setIsOrganizationModal(!isOrganizationModal)}
        content={
          <OrganizationCustomerRecordModal
            mode="add"
            modalClose={() => setIsOrganizationModal(false)}
            OutletId={newCustomerId!}
            onSuccess={(createdOrgDataId) => {
              setIsOrganizationModal(false);
              setNewOutletOrgDataId(createdOrgDataId);
              setIsBeatModal(true); // <-- Open Beat modal after organization
            }}
          />
        }
      />


      <RouteModal
  size="md"
  isOpen={isBeatModal}
  title="Add Beat"
  toggle={() => setIsBeatModal(!isBeatModal)}
  content={
    <BeatOutletModal
      customerId={newCustomerId!}
      modalClose={() => setIsBeatModal(false)}
      mode="add"
      OutletOrgId={newOutletOrgDataId!} 
    />
  }
/>


      </div>   
    )
}
export default CustomerScreen;